// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"e1b1ae72","239":"2383f2a4","667":"a59861da"}[chunkId] + ".chunk.js";
};